interface FieldProps {
  label: string;
  value: React.ReactNode;
  /** Hace span 2 cols del grid */
  wide?: boolean;
}

export function Field({ label, value, wide }: FieldProps) {
  return (
    <div className={wide ? "col-span-2" : undefined}>
      <div className="nx-eyebrow mb-1">{label}</div>
      <div className="text-sm text-fg break-words">
        {value === null || value === undefined || value === "" ? (
          <span className="text-fg-subtle">—</span>
        ) : (
          value
        )}
      </div>
    </div>
  );
}

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

export function Section({ title, children }: SectionProps) {
  return (
    <section>
      <h3 className="text-2xs font-semibold uppercase tracking-wider text-fg-subtle mb-3 pb-1 border-b border-border-subtle">
        {title}
      </h3>
      <div className="grid grid-cols-2 gap-x-4 gap-y-3">{children}</div>
    </section>
  );
}

export function Link({ href, children }: { href: string; children: React.ReactNode }) {
  if (!href) return <span className="text-fg-subtle">—</span>;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-accent hover:underline break-all"
    >
      {children ?? href}
    </a>
  );
}

export function Chips({ items }: { items: string[] }) {
  if (!items || items.length === 0) {
    return <span className="text-fg-subtle">—</span>;
  }
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((it, i) => (
        <span
          key={i}
          className="inline-flex items-center text-xs bg-bg-subtle border border-border-subtle text-fg-muted rounded px-1.5 py-0.5"
        >
          {it}
        </span>
      ))}
    </div>
  );
}
